import { competitionPredictedLineupsWidget } from '@sky-it-livedata/livedata-football-widgets';
import { IPredictedLineupsHp, PredictedLineupsHp } from '@sky-it-livedata/livedata-sports-design-system';
import React, { useEffect } from 'react';

import { IWrapperModel } from '../../typings/common-types';
import { getModelFromUseService, isValidObject } from '../../utils/props-validator';
import { useService } from '../hooks/useService';

export interface IPredictedLineupsHpWrapper extends IWrapperModel<IPredictedLineupsHp> {}

const CompetitionPredictedLineupsWrapper = ({ query, initialModel, live = false }: IPredictedLineupsHpWrapper) => {
  const { model } = useService({
    live,
    query,
    initialValue: initialModel,
    widget: competitionPredictedLineupsWidget,
  });

  useEffect(() => {
    /**
     * Try lo LOCATE match passed with HASH, e.g. https://sport.sky.it/calcio/serie-a/probabili-formazioni#lecce-lazio
     * UGLY, but don't wanna import REACT-ROUTER only to listening to HASH CHANGES!
     */
    const hash: string = location.hash.replace('#', '');
    if (hash.length > 0) {
      setTimeout(() => {
        const goto: HTMLElement | null = document.getElementById(hash);
        goto && goto.scrollIntoView(true);
      }, 1000);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const args: IPredictedLineupsHp = {
    ...getModelFromUseService(model),
  };

  return isValidObject(args) ? <PredictedLineupsHp {...args} /> : null;
};

export default CompetitionPredictedLineupsWrapper;
